// Mock Data for Hematology Category

const baseProducts = [
    {
        id: "med-hema-1",
        name: "Rivaroxaban 20mg",
        genericName: "Brand: Xarelto",
        indication: "Blood Clot Prevention",
        price: "$42",
        originalPrice: "$500",
        savings: "91%",
        description: "An anticoagulant (blood thinner) that prevents the formation of blood clots. Used to reduce the risk of stroke in people with atrial fibrillation and to treat/prevent deep vein thrombosis (DVT).",
        dosage: "Typically taken once daily with the evening meal. Do not skip doses.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from moisture.",
        sideEffects: "Increased risk of bleeding, bruising easily, or prolonged bleeding from minor cuts.",
        category: "Anticoagulants/Blood Thinners"
    },
    {
        id: "med-hema-2",
        name: "Deferasirox 500mg",
        genericName: "Brand: Jadenu",
        indication: "Iron Overload",
        price: "$1,260",
        originalPrice: "$4,200",
        savings: "70%",
        description: "An iron-chelating agent used to treat chronic iron overload caused by frequent blood transfusions in conditions like thalassemia or myelodysplastic syndromes.",
        dosage: "Taken once daily on an empty stomach or with a light meal. Can be dissolved in liquid.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a dry place.",
        sideEffects: "Nausea, vomiting, diarrhea, abdominal pain, or mild rash.",
        category: "Iron Chelators"
    },
    {
        id: "med-hema-3",
        name: "Eltrombopag 75mg",
        genericName: "Brand: Promacta",
        indication: "Thrombocytopenia",
        price: "$2,550",
        originalPrice: "$8,500",
        savings: "70%",
        description: "Used to treat low blood platelet counts (thrombocytopenia) in adults with chronic immune (idiopathic) thrombocytopenic purpura (ITP), helping prevent dangerous bleeding.",
        dosage: "Taken strictly on an empty stomach, away from calcium-rich foods or antacids.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature. Keep in original container to protect from light.",
        sideEffects: "Nausea, diarrhea, upper respiratory infection, or liver function changes.",
        category: "Platelet-Stimulating Agents"
    },
    {
        id: "med-hema-4",
        name: "Romiplostim 250mcg",
        genericName: "Brand: Nplate",
        indication: "Thrombocytopenia",
        price: "$1,740",
        originalPrice: "$5,800",
        savings: "70%",
        description: "A thrombopoietin (TPO) receptor agonist given to increase platelet counts in patients with immune thrombocytopenia (ITP) to lower the risk of bleeding.",
        dosage: "Administered as a weekly subcutaneous injection by a healthcare provider.",
        packaging: "Contains 1 Single-use Vial",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated between 2°C and 8°C. Do not freeze.",
        sideEffects: "Headache, joint pain, dizziness, or pain in the extremities.",
        category: "Platelet-Stimulating Agents"
    },
    {
        id: "med-hema-5",
        name: "Hydroxyurea 500mg",
        genericName: "Brand: Hydrea",
        indication: "Sickle Cell / Cancers",
        price: "$80",
        originalPrice: "$260",
        savings: "69%",
        description: "Used to reduce the frequency of painful crises and the need for blood transfusions in patients with sickle cell anemia. Also used to treat certain types of blood cancers.",
        dosage: "Taken orally once daily as prescribed. Requires careful handling (wash hands).",
        packaging: "Contains 100 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a tightly closed container.",
        sideEffects: "Lowered blood cell counts (increasing infection risk), nausea, or mouth sores.",
        category: "Chemotherapy/Sickle Cell Agents"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-hema-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Hematology and Blood Disorders Treatment",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of severe blood disorders, anemias, and clotting conditions. Sourced from WHO-GMP certified facilities.`,
            dosage: "Strictly as prescribed by your hematologist.",
            packaging: "Contains 30 Tablets/Capsules",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific hematological side effects. Regular blood counts required.",
            category: "General Hematological Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const hematologyProducts = [...baseProducts, ...generateAlphabetMeds()];

export const hematologyHeroData = {
    title: "Hematology",
    subtitle: "Blood disorders, anemia, and clotting condition treatments",
    description: "Secure affordable, life-saving therapies for complex blood conditions including immune thrombocytopenia (ITP), deep vein thrombosis, and iron overload. Access WHO-GMP certified generics and save up to 90%.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "75%", label: "Average Savings" }
    ]
};

export const hematologyCategories = [
    "All Categories",
    "Anticoagulants/Blood Thinners",
    "Platelet-Stimulating Agents",
    "Iron Chelators",
    "Chemotherapy/Sickle Cell Agents",
    "General Hematological Care"
];

export const hematologyTrustBadges = [
    { text: "WHO-GMP Certified", icon: "ShieldCheck" },
    { text: "Verified Potency", icon: "Activity" },
    { text: "Expert Sourcing", icon: "UserCheck" },
    { text: "Secure Global Delivery", icon: "Globe" }
];

export const hematologyFAQs = [
    {
        question: "Do I need a prescription to order these blood thinners or biologics?",
        answer: "Yes, strictly. All hematology treatments, including anticoagulants like Rivaroxaban and platelet stimulators like Eltrombopag, require a valid prescription due to the need for careful medical monitoring."
    },
    {
        question: "How do I know the generic anticoagulant is as safe as the brand name?",
        answer: "Our generic medications are sourced from highly regulated, WHO-GMP certified facilities and are proven bioequivalent. This means they deliver the identical clinical effect and safety profile as expensive brands."
    },
    {
        question: "Can you ship temperature-controlled hematology injections?",
        answer: "Yes. Medications like Romiplostim that require refrigeration are shipped via expedited cold-chain cargo with temperature loggers to ensure absolute integrity upon arrival."
    },
    {
        question: "Is it possible to order a multi-month supply for a chronic condition?",
        answer: "Absolutely. For conditions like ITP or recurrent DVT, we can supply 3, 6, or even 12-month regimens, ensuring you never run out and saving you significantly on shipping."
    }
];

export const hematologyTestimonials = [
    {
        name: "William H.",
        country: "United States",
        savings: "$68,000 annually",
        condition: "Chronic ITP",
        medication: "Eltrombopag (Promacta Generic)",
        text: "The astronomical cost of Promacta in the US left me terrified of severe bleeding episodes. Finding this reliable generic source literally saved my life and my finances."
    },
    {
        name: "Elena V.",
        country: "Spain",
        savings: "$4,500 annually",
        condition: "DVT Risk",
        medication: "Rivaroxaban",
        text: "Getting Xarelto was breaking the bank. The generic version works flawlessly. My blood tests remain stable, and the shipping is fast and discreet."
    },
    {
        name: "Ahmed K.",
        country: "UAE",
        savings: "$24,000 annually",
        condition: "Thalassemia (Iron Overload)",
        medication: "Deferasirox",
        text: "Frequent transfusions meant I desperately needed Deferasirox. This pharmacy provides exceptional quality Jadenu generics at a fraction of local costs here."
    }
];

export const hematologySectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Discover how patients worldwide manage life-threatening blood disorders with our affordable treatments."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important safety and logistical information about ordering specialty hematology medicines."
    },
    midPageCTA: {
        title: "Need a Specialized Hematology Treatment?",
        description: "We source critical anticoagulants, chelators, and platelet-stimulators. Let our procurement experts find the exact bioequivalent generic for you.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Sourcing Assistance"
    },
    finalCTA: {
        title: "Secure Your Hematology Health Today",
        description: "Don't let high drug costs prevent you from managing serious blood disorders. Start saving safely today.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
